const scholarshipValues = [
  { title: "All", value: "" },
  { title: "Available", value: "yes" },
  { title: "Not Available", value: "no" },
];

export default scholarshipValues;
